// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Preloader_wrapper__3t_O-","loading":"Preloader_loading__2EkIt"};